/**
 * Invitation disagree script class
 *
 * @package    Layout
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { disagreeInvitation } from 'Actions/invitation';

@connect(
    null,
    dispatch => ({
        disagreeInvitation: token => dispatch(disagreeInvitation(token)),
    })
)
export default class Disagree extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        match: PropTypes.object.isRequired,
        disagreeInvitation: PropTypes.func.isRequired,
    };

    /**
     * Init
     */
    componentDidMount() {
        const {
            match: {
                params: { token },
            },
            disagreeInvitation,
        } = this.props;

        disagreeInvitation(token);
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Invitations/Disagree/Disagree.jsx